import { mapEgdGame } from "src/utils/mapEgdGame";

/**
 * @typedef {Object} EgdJackpotMeter
 * @property {import('src/utils/mapEgdGame').EgdGameCard | null} game - The related game
 *   (including `game.id`), resolved server-side via the `depth` query param; `null` if
 *   the relation wasn't populated.
 * @property {number} amount
 * @property {string} last_update_date
 * @property {string} last_update_time
 * @property {string} last_hit_date
 * @property {string} last_hit_time
 * @property {string} location
 */

/**
 * Maps a Payload `egd-jackpot-meters` document (fetched with `depth=2` so
 * `game` and `game.imageMedia` are resolved) to the shape consumed by
 * gameListUtils.
 *
 * @param {Record<string, unknown>} doc
 * @param {'en' | 'fr'} [locale]
 * @returns {EgdJackpotMeter}
 */
export function mapEgdJackpot(doc, locale = "en") {
  const safeDoc =
    doc && typeof doc === "object" && !Array.isArray(doc) ? doc : {};

  const gameDoc =
    safeDoc.game && typeof safeDoc.game === "object" && !Array.isArray(safeDoc.game)
      ? safeDoc.game
      : null;

  return {
    game: gameDoc ? mapEgdGame(gameDoc, locale) : null,
    amount: typeof safeDoc.amount === "number" ? safeDoc.amount : 0,
    last_update_date:
      typeof safeDoc.lastUpdatedAt === "string" ? safeDoc.lastUpdatedAt : "",
    last_update_time:
      typeof safeDoc.lastUpdateTime === "string" ? safeDoc.lastUpdateTime : "",
    last_hit_date: typeof safeDoc.lastHitAt === "string" ? safeDoc.lastHitAt : "",
    last_hit_time:
      typeof safeDoc.lastHitTime === "string" ? safeDoc.lastHitTime : "",
    location: typeof safeDoc.location === "string" ? safeDoc.location : "",
  };
}

/**
 * @param {{ docs?: unknown[] }} payloadResponse
 * @param {'en' | 'fr'} [locale]
 * @returns {EgdJackpotMeter[]}
 */
export function mapEgdJackpotsResponse(payloadResponse, locale = "en") {
  const docs = Array.isArray(payloadResponse?.docs) ? payloadResponse.docs : [];
  return docs.map((doc) => mapEgdJackpot(doc, locale));
}
